<template>
  <el-card>
    <!-- 表单 -->
    <div class="top">
      <div class="searchForm">
        <el-form
          :inline="true"
          ref="searchForm"
          :model="searchForm"
          class="searchForm"
          @submit.native.prevent
          @keyup.enter.native="searchList"
        >
          <el-form-item label="" prop="type" v-if="!isSystem">
            <el-select
              v-model="searchForm.type"
              clearable
              placeholder="请选择类型"
              @clear="searchList"
              style="width: 250px"
              @change="searchList"
            >
              <el-option
                v-for="(item, key) in AI_AGENT_TOOL_CUSTOM_TYPE"
                :key="key"
                :label="item"
                :value="key"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="" prop="keyword">
            <el-input
              v-model="searchForm.name"
              clearable
              placeholder="请输入工具名称"
              @clear="searchList"
              style="width: 250px"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchList">查 询</el-button>
            <el-button @click="resetForm">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="right">
        <el-button
          class="float-right"
          type="primary"
          @click="onAdd"
          v-if="!isSystem && jurisdiction.aiAgentAiAgentTools_agent_create"
        >
          新建工具
        </el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table :data="list">
      <el-table-column label="工具名称" prop="name"></el-table-column>
      <el-table-column label="描述" prop="description"></el-table-column>
      <el-table-column label="类型" prop="type">
        <template slot-scope="scope">
          {{ AI_AGENT_TOOL_TYPE[scope.row.type] }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <template>
            <el-button @click="onDetail(scope.row)" type="text" size="small">详情</el-button>
            <el-button
              v-if="jurisdiction.aiAgentAiAgentTools_agent_edit"
              @click="onEdit(scope.row)"
              type="text"
              size="small"
              :disabled="scope.row.type === 'grpc' || isSystem"
            >
              编辑
            </el-button>
            <el-button
              v-if="jurisdiction.aiAgentAiAgentTools_agent_delete"
              @click="onDelete(scope.row)"
              type="text"
              size="small"
              :disabled="scope.row.type === 'grpc' || isSystem"
            >
              移除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    />
    <create-edit-tool
      :visible="visible"
      :row="editData"
      :type="openType"
      @close="visible = false"
      @refresh="getList"
    />
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateEditTool from './createEditTool.vue';
import { AI_AGENT_TOOL_TYPE, AI_AGENT_TOOL_CUSTOM_TYPE } from '@/utils/constant';

function filterEmptyPayload(payload = {}) {
  const r = {};
  for (const k of Object.keys(payload)) {
    if (payload[k] !== '') {
      r[k] = payload[k];
    }
  }
  return r;
}

export default {
  components: { CreateEditTool },
  props: {
    isSystem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AI_AGENT_TOOL_TYPE,
      AI_AGENT_TOOL_CUSTOM_TYPE,
      // 搜索表单
      searchForm: {
        name: '',
        type: '',
      },
      payload: {
        limit: 10,
        offset: 0,
      },
      page: 1,
      pageSize: 10,
      total: 0,
      // 表格
      loading: false,
      list: [],
      // 弹窗
      visible: false,
      editData: {},
      openType: 'create',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'aiAgentAiAgentTools_agent_create',
        'aiAgentAiAgentTools_agent_edit',
        'aiAgentAiAgentTools_agent_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  async created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      this.payload = {
        ...filterEmptyPayload(this.payload),
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
        is_system: this.isSystem,
      };
      try {
        const { agent_tools: agentTools, total_count: total } = await this.$request({
          url: this.$api.listAgentTools,
          data: this.payload,
        });
        this.list = agentTools;
        this.total = parseInt(total);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    onAdd() {
      this.editData = {};
      this.openType = 'create';
      this.visible = true;
    },
    onEdit(row) {
      this.editData = row;
      this.openType = 'edit';
      this.visible = true;
    },
    onDetail(row) {
      this.$router.push({
        name: `ai-agent-tool-detail`,
        query: { id: row.id, is_system: this.isSystem },
      });
    },
    async onDelete(row) {
      this.$confirm(`确定移除工具[${row.name}]吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = {
          id: row.id,
        };
        console.log(data);
        await this.$request({
          url: this.$api.deleteAgentTools,
          data,
        });
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.getList();
      });
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.payload.name = this.searchForm.name || '';
      this.payload.type = this.searchForm.type || '';
      this.getList();
    },
    resetForm() {
      this.searchForm.name = '';
      this.searchForm.type = '';
      delete this.payload.name;
      delete this.payload.type;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/tab.scss';
@import '@/styles/element/table.scss';
@import '@/styles/element/dropdown.scss';
@import '@/styles/element/pagination.scss';
.top {
  display: flex;
  .searchForm {
    flex: 1;
  }
}
.app-select {
  width: 120px;
}
</style>
